// extracted by mini-css-extract-plugin
module.exports = {"container":"container--3kHpS","icon":"icon--1YZ2c","text":"text--2RvYM","money":"money--1ovSe"};